<template>
  <div
    class="search-content"
    @mouseleave="mouseAction(true)"
    @mouseenter="mouseAction(false)"
    v-auth="['auth_site_header_search', 'auth_device_header_search', 'auth_docs_header_search']"
  >
    <ul class="search-type">
      <li
        :class="active === 'device' ? 'active' : ''"
        @click="clickTab('device')"
        v-if="hasDeviceAuth()"
      >
        {{ $t('com_header_device') }}
      </li>
      <li :class="active === 'site' ? 'active' : ''" @click="clickTab('site')" v-if="hasSiteAuth()">
        {{ $t('com_header_station') }}
      </li>
      <li :class="active === 'doc' ? 'active' : ''" @click="clickTab('doc')" v-if="hasDocsAuth()">
        {{ $t('com_header_docs') }}
      </li>
    </ul>
    <!-- 加载状态 -->
    <Loading :show="loading" v-if="loading" class="search-loading" />
    <!-- 列表 -->
    <div class="search-result" v-else>
      <div class="search-tip" v-if="searchValue">
        {{ $t('com_header_search_result1') }}
        <span>{{ this.searchValue }} </span>
        {{ $t('com_header_search_result2') }}
        <i v-if="active === 'device'"> {{ this.deviceList.length }}</i>
        <i v-if="active === 'site'"> {{ this.siteList.length }}</i>
        <i v-if="active === 'doc'"> {{ this.docsList.length }}</i>
        {{ $t('com_header_search_result3') }}
      </div>

      <!-- 设备列表 -->
      <dl class="search-list" v-if="active === 'device' && deviceList && deviceList.length > 0">
        <!-- 设备列表 -->
        <dd v-for="(item, index) in deviceList" :key="index">
          <!-- 设备 -->
          <router-link
            :to="{
              name: 'DeviceDetail',
              params: { id: item.devId },
            }"
            v-if="item.devId && hasDeviceAuth()"
            @click="
              () => {
                this.$emit('close');
              }
            "
          >
            {{ item.name }}
          </router-link>
        </dd>
      </dl>
      <Empty v-if="active === 'device' && deviceList && deviceList.length === 0" class="empty" />

      <!-- 站点列表 -->
      <dl class="search-list" v-if="active === 'site' && siteList && siteList.length > 0">
        <dd v-for="(item, index) in siteList" :key="index">
          <router-link
            :to="{
              name: 'SiteDetail',
              params: { id: item.stationId },
            }"
            v-if="item?.stationId && hasSiteAuth()"
          >
            {{ item.name }}
          </router-link>
        </dd>
      </dl>
      <Empty v-if="active === 'site' && siteList && siteList.length === 0" class="empty" />

      <!-- 文档列表 -->
      <dl class="search-list" v-if="active === 'doc' && docsList && docsList.length > 0">
        <dd v-for="(item, index) in docsList" :key="index">
          <!-- 文档 -->
          <router-link
            :to="{
              name: 'DocsDetail',
              params: { id: item.id },
            }"
            v-if="hasDocsAuth()"
          >
            {{ item.title }}
          </router-link>
        </dd>
      </dl>
      <Empty v-if="active === 'doc' && docsList && docsList.length === 0" class="empty" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { SiteQuery } from '@/api/site';
import { DeviceSearch } from '@/api/device';
import { searchDocument } from '@/api/docs';
import { hasApiMenuPermission } from '@/libs/permissions';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    mouseAction: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      // 当前激活的tab
      active: '',

      // 加载中
      loading: false,

      // 搜索定时器
      timer: null,

      // 站点列表
      list: [],

      // 设备列表
      deviceList: [],

      // 文档列表
      docsList: [],

      // 站点列表
      siteList: [],

      // 搜索展示的值
      searchValue: '',
    };
  },
  created() {
    if (this.hasDeviceAuth()) {
      this.active = 'device';
    } else if (this.hasSiteAuth()) {
      this.active = 'site';
    } else {
      this.active = 'doc';
    }
    if (this.value) {
      this.clickTab();
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    // 是否有设备搜索及详情的权限
    hasDeviceAuth() {
      return hasApiMenuPermission('and', ['auth_device_detail', 'auth_device_header_search']);
    },

    // 是否有站点搜索及详情的权限
    hasSiteAuth() {
      return hasApiMenuPermission('and', ['auth_site_detail', 'auth_site_header_search']);
    },

    // 是否有文档搜索及详情的权限
    hasDocsAuth() {
      return hasApiMenuPermission('and', ['auth_docs_list', 'auth_docs_header_search']);
    },

    // 搜索站点
    searchSite() {
      if (!this.value) {
        return;
      }

      this.loading = true;
      SiteQuery({
        keyword: this.value,
      })
        .then(res => {
          if (res.code === 0) {
            this.siteList = res.data || [];
          }
        })
        .finally(() => {
          this.loading = false;
          this.searchValue = this.value;
        });
    },

    // 搜索设备
    searchDevice() {
      if (!this.value) {
        return;
      }

      this.loading = true;
      DeviceSearch({
        keyword: this.value,
      })
        .then(res => {
          if (res.code === 0) {
            this.deviceList = res.data || [];
          }
        })
        .finally(() => {
          this.loading = false;
          this.searchValue = this.value;
        });
    },

    // 搜索文档
    searchDocs() {
      if (!this.value) {
        return;
      }

      this.loading = true;
      searchDocument({
        keyword: this.value,
        wcIds: '',
        pageNo: 1,
        pageSize: 10000,
      })
        .then(res => {
          if (res.code === 0) {
            this.docsList = res.data || [];
          }
        })
        .finally(() => {
          this.loading = false;
          this.searchValue = this.value;
        });
    },

    // 切换tab
    clickTab(type) {
      if (type) {
        this.active = type;
      }
      if (this.active === 'device') {
        // 搜索设备
        this.searchDevice();
      } else if (this.active === 'site') {
        // 搜索站点
        this.searchSite();
      } else if (this.active === 'doc') {
        // 搜索文档
        this.searchDocs();
      }
    },

    reset() {
      this.deviceList = [];
      this.siteList = [];
      this.docsList = [];
      this.searchValue = '';
    },
  },
};
</script>
<style lang="less" scoped>
.search-content {
  font-size: 12px;
  color: #000;
  width: 350px;
  height: 300px;
  padding: 5px;

  .search-loading {
    margin-top: 50px;
  }

  // tab
  .search-type {
    padding: 0;
    margin: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: rgba(0, 0, 0, 0.04) solid 1px;
    li {
      width: 50%;
      padding: 0;
      margin: 0;
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: rgba(0, 0, 0, 0.88);
      font-size: 14px;
      font-weight: 400;
      position: relative;
      cursor: pointer;

      &.active {
        color: #1838d9;
        font-size: 14px;
        font-weight: 600;

        &::before {
          content: ' ';
          display: block;
          width: 100%;
          height: 2px;
          background-color: #1838d9;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }

  // result
  .search-result {
    .search-tip {
      padding: 5px 12px;
      line-height: 22px;
      color: #a0a0a7;
      font-weight: 400;
      font-size: 12px;
      padding-bottom: 7px;

      span {
        color: #f00;
        font-weight: bold;
        word-wrap: break-word;
        word-break: break-all;
      }

      i {
        font-size: 14px;
        font-weight: 600;
        color: #1838d9;
        font-style: normal;
        padding: 0 5px;
      }
    }

    .search-list {
      height: 215px;
      overflow: auto;
      dd {
        padding: 2px 6px 5px 12px;
        line-height: 22px;
        color: #45454a;
        font-weight: 400;
        font-size: 14px;
        margin: 0;
        cursor: pointer;

        a {
          color: #45454a;
          display: block;
          width: 100%;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.04);

          a {
            color: @primary-color;
          }
        }
      }
    }

    .empty {
      padding-top: 50px;
    }
  }
}
</style>
